import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { BikeModel } from '../models/bike.model';
import { Estate } from '../utils/enum.util';

@Injectable()

export class BikeService2 {

    list: any;
    current: any;

    isOpen = false;

    private antiRebound = 300;
    private timestamp   = 0;
    private antiReboundField: string;

    functionSave: any = null;

    constructor(public apiService: ApiService) {
        this.reset();
    }

    reset() {
        this.list    = [];
        this.current = null;
    }

    getAll(privateId) {
        this.reset();

        this.apiService.get('client/' + privateId + '/bikes', '').subscribe(res=> {
            res.data.forEach((e)=> {
                this.list.push(BikeModel.j2o(e, this));
            });
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    del(bike) {
        let tmp = bike;

        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i] == bike) {
                this.list.splice(i, 1);
            }
        }
        this.current = null;
        this.apiService.delete('bike/' + tmp.id, '').subscribe(_res=> {

        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    changeUsed(bike) {
        bike.used = !bike.used;
        this.put(bike, 'used');
    }

    post() {
        if (this.current.notSave) {
            this.functionSave.modelChange();
            return;
        }
        let tmp        = {
            brand: this.current.brand,
            model: this.current.model
        }
        //antiRebounce
        this.timestamp = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.list.push(this.current);
                this.apiService.post('client/' + this.current.clientPrivateId + '/bike', tmp).subscribe(res=> {
                    this.current.id            = res.data.id;
                    this.current.created       = new Date();
                    this.current.state.brand   = Estate.Save;
                    this.current.state.model   = Estate.Save;
                    this.current.state.numCad  = Estate.Save;
                    this.current.state.size    = Estate.Save;
                    this.current.state.comment = Estate.Save;
                    this.current.antiMultiPost = false;
                }, (_err)=> {
                    this.apiService.error(_err);
                });
            }
        }, this.antiRebound);
    }

    addNew(privateId) {
        let tmp             = new BikeModel(this);
        tmp.clientPrivateId = privateId;
        this.current        = tmp;
        this.isOpen         = true;
    }

    put(bike: BikeModel, field: string) {
        if (bike.notSave) {
            this.functionSave.modelChange();
            return;
        }
        let data = {};

        bike.state[field] = Estate.Saving;

        data = {[field]: bike[field].toString()};

        //antiRebounce
        this.antiReboundField = field;
        this.timestamp        = new Date().getTime();
        setTimeout(()=> {
            if (this.antiReboundField != field || this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('bike/' + bike.id, data).subscribe((_res)=> {
                    bike.state[field] = Estate.Save;
                }, (_err)=> {
                    this.apiService.error(_err);
                    bike.state[field] = Estate.Error;
                });
            }
        }, this.antiRebound);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/bike2.service.ts